import { render } from "./Feeds.vue?vue&type=template&id=5df4b249&ts=true"
import script from "./Feeds.vue?vue&type=script&lang=ts"
export * from "./Feeds.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\ATTP_PC03\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__